import { jsx as _jsx } from "react/jsx-runtime";
import { createStore } from 'jotai';
import { createContext, useContext, useEffect, useMemo } from 'react';
export * from './hooks';
export const ScopedProviderContext = createContext(new Map());
/**
 * a simple provider for reading atoms from children inside React DOM tree
 * support inheritance and SAME_LEVEL atom computing.
 */
export const ScopedProvider = (props) => {
    const { atomsWithHydration = [], atoms = [], children } = props;
    const scopedStore = useMemo(createStore, []);
    const parentScopedContext = useContext(ScopedProviderContext);
    const scopedContextValue = useMemo(() => {
        const map = new Map(parentScopedContext);
        atomsWithHydration.forEach(([atom, data]) => {
            map.set(atom, scopedStore);
            scopedStore.set(atom, data);
        });
        atoms.forEach((atom) => {
            map.set(atom, scopedStore);
        });
        return map;
    }, [scopedStore, parentScopedContext]);
    atomsWithHydration.forEach(([atom, data]) => {
        useEffect(() => {
            scopedStore.set(atom, data);
        }, [data]);
    });
    return _jsx(ScopedProviderContext.Provider, { value: scopedContextValue, children: children });
};
